import React, { useState } from "react";
import { AppBar, Toolbar, Typography, IconButton, InputBase } from "@mui/material";
import { Search, Close } from "@mui/icons-material";

// Title on the left, a search icon on the right that toggles into an inline
// keyword search field (order no., customer name, or product name — matches
// what OrderController@getOrders's `search` param actually filters on).
export default function OrdersAppBar({ title, search, onSearchChange }) {
  const [searchOpen, setSearchOpen] = useState(false);

  const closeSearch = () => {
    setSearchOpen(false);
    onSearchChange("");
  };

  return (
    <AppBar position="sticky" color="default" elevation={0} sx={{ bgcolor: "#fff", borderBottom: "1px solid", borderColor: "divider" }}>
      <Toolbar sx={{ gap: 1 }}>
        {searchOpen ? (
          <>
            <InputBase
              autoFocus
              fullWidth
              placeholder={`Search ${title.toLowerCase()}`}
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              sx={{ flex: 1 }}
            />
            <IconButton onClick={closeSearch} size="small">
              <Close />
            </IconButton>
          </>
        ) : (
          <>
            <Typography variant="h6" fontWeight={800} sx={{ flex: 1 }}>
              {title}
            </Typography>
            <IconButton onClick={() => setSearchOpen(true)} size="small">
              <Search />
            </IconButton>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}
